import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { BRAND, purchaseNotice } from '../data/resinContent';
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(show);
  }, []);
  return <AnimatePresence data-id="element-283" data-mp="2qvhwbiy3thjx">
      {visible && <motion.aside initial={{
      x: -24,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -24,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} aria-label="Recent order" className="fixed bottom-24 left-4 z-30 hidden max-w-[19rem] items-start gap-3 border border-charcoal-600 bg-charcoal-900/95 px-4 py-3 shadow-card backdrop-blur lg:bottom-6 lg:flex" data-id="element-284" data-mp="2lvv8ygokakxe">
          <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-champagne" strokeWidth={2} aria-hidden="true" data-id="element-285" data-mp="b326wlksi7f2" />
          <div className="min-w-0" data-id="element-286" data-mp="1u681panz98zh">
            <p className="text-[9px] font-semibold uppercase tracking-[0.18em] text-champagne" data-id="element-287" data-mp="1z5c8xvrccwn6">Recent order</p>
            <p className="mt-1 text-[13px] leading-snug text-ivory-100" data-id="element-288" data-mp="236o2udh90416">
              <span className="font-medium" data-id="element-289" data-mp="286adcf5oz66a">{purchaseNotice.name}</span> from {purchaseNotice.location} got {BRAND}
            </p>
            <p className="mt-1 text-[10px] uppercase tracking-[0.14em] text-muted" data-id="element-290" data-mp="1bgszve0gwfu1">
              {purchaseNotice.minutesAgo} minutes ago
            </p>
          </div>
          <button type="button" onClick={() => setVisible(false)} className="-mr-1 -mt-1 shrink-0 p-1 text-muted transition-colors duration-150 ease-out hover:text-ivory-100" data-id="element-291" data-mp="1kgoextx58uzc">
            <XIcon className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" data-id="element-292" data-mp="rsk998ekohwn" />
            <span className="sr-only" data-id="element-293" data-mp="wr3sh11s7flb">Dismiss notification</span>
          </button>
        </motion.aside>}
    </AnimatePresence>;
}